import { z } from "zod";

export const ProfileSchema = z.object({
	age: z.number().min(0, "Age must be a positive number"),
	gender: z.enum(["Male", "Female", "Other"]).optional(),
	email: z.string().email("Invalid email address"),
	userName: z
		.union([
			z
				.string()
				.min(2, "Display name must be at least 2 characters")
				.max(30, "Display name must be at most 30 characters"),
			z.literal(""),
		])
		.optional(),
	phone: z.string().optional(),
	location: z.string().optional(),
	address: z.string().optional(),
	city: z.string().optional(),
	state: z.string().optional(),
	country: z.string().optional(),
});

export type ProfileType = z.infer<typeof ProfileSchema>;
